import { GET_MANY_REFERENCE, CREATE, GET_ONE, UPDATE } from 'react-admin';
import { convertToTimezoneToUtc } from '../../shared/utils/date';
import utils from '../../shared/utils';

const dataBusinessUnitInvoices = (instance, type, { field, filter, id, actionType, payload }) => {
  const opt = {};
  switch (type) {
    case GET_MANY_REFERENCE: {
      // Convert parameters
      const query = new URLSearchParams();

      if (filter) {
        query.append('startDate', convertToTimezoneToUtc(filter.startDate, filter.timezone));
        query.append('endDate', convertToTimezoneToUtc(filter.endDate, filter.timezone, 'eod'));
      }

      const role = utils.getRoles(id);

      if (role === 'owner') {
        opt.url = `/billing/fleets/${localStorage.getItem(
          'fleetID'
        )}/business/instant/entities/${id}/invoices/tripDetails`;
      } else {
        opt.url = `/billing/fleets/${localStorage.getItem('fleetID')}/entity/${id}/invoices/tripDetails`;
      }
      opt.method = 'GET';
      opt.params = query;

      break;
    }
    case GET_ONE: {
      switch (field) {
        default:
          opt.url = `/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}`;
          opt.method = 'GET';
          break;
      }
      break;
    }
    case CREATE: {
      switch (field) {
        case 'refund':
          opt.url = `/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/refund`;
          opt.method = 'POST';
          opt.data = { ...payload };
          break;

        case 'retryPayment':
          opt.url = `/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/retry-payment`;
          opt.method = 'POST';
          break;

        default:
          break;
      }
      break;
    }
    case UPDATE: {
      switch (field) {
        case 'cancel':
          opt.url = `/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/cancel`;
          opt.method = 'PUT';
          break;

        case 'setAsPaid':
          opt.url = `/billing/fleets/${localStorage.getItem('fleetID')}/invoices/${id}/externalPayment`;
          opt.method = 'PUT';
          opt.data = { ...payload };
          break;
        default:
          break;
      }
      break;
    }
    default:
      throw new Error(`Unsupported action type ${actionType}`);
  }

  return instance(opt);
};

export default dataBusinessUnitInvoices;
